export const MessagePort = 1
export const ModuleWorker = 2
export const ReferencePort = 3
export const ModuleWorkerWithMessagePort = 4
export const Electron = 5

export const Auto = ModuleWorker
